import { styled } from '@mui/material/styles';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useTranslation } from '@hooks';
import { POST_CHANNEL } from '@constants/social-posts';
import { PhoneFrame, BrandAvatar } from './styles';
import { toHandle } from './utils';
import MediaSlide from './MediaSlide';

const FONT = '-apple-system, BlinkMacSystemFont, "Helvetica Neue", Helvetica, Arial, sans-serif';

const Card = styled(PhoneFrame)({
    fontFamily: FONT,
    position: 'relative',
    backgroundColor: '#000',
});

const Overlay = styled('div')({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    padding: '8px 10px',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    background: 'linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0))',
    zIndex: 1,
});

const Segments = styled('div')({
    display: 'flex',
    gap: 4,
});

const Segment = styled('span', { shouldForwardProp: p => p !== 'active' })(({ active }) => ({
    flex: 1,
    height: 2.5,
    borderRadius: 2,
    backgroundColor: active ? 'rgba(255, 255, 255, 0.95)' : 'rgba(255, 255, 255, 0.35)',
}));

const WhoRow = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 8,
});

const RingedAvatar = styled('div')({
    padding: 2,
    background: 'linear-gradient(45deg, #f9ce34, #ee2a7b, #6228d7)',
    borderRadius: '50%',
});

const Name = styled('div')({
    flex: 1,
    color: '#fff',
    fontSize: 13,
    fontWeight: 600,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textShadow: '0 1px 2px rgba(0, 0, 0, 0.4)',
});

const Hint = styled('div')({
    position: 'absolute',
    bottom: 10,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'rgba(255, 255, 255, 0.85)',
    fontSize: 11,
    letterSpacing: '0.04em',
    textShadow: '0 1px 2px rgba(0, 0, 0, 0.5)',
    zIndex: 1,
});

const PlatformCardStory = ({ platform, pageName, handle: realHandle, locationLogo, media }) => {
    const { t } = useTranslation();
    const displayName = platform === POST_CHANNEL.INSTAGRAM_STORY ? realHandle || toHandle(pageName) : pageName;
    const storyMedia = (media || []).slice(0, 1);

    return (
        <Card>
            <MediaSlide media={storyMedia} aspectRatio="9 / 16" dark emptyLabel={t('SocialPosts.noMediaPreview')} />
            <Overlay>
                <Segments>
                    <Segment active />
                    <Segment />
                    <Segment />
                </Segments>
                <WhoRow>
                    <RingedAvatar>
                        <BrandAvatar name={pageName} image={locationLogo} size={28} color="#6228d7" />
                    </RingedAvatar>
                    <Name>{displayName}</Name>
                    <MoreHorizIcon sx={{ color: '#fff', fontSize: 20 }} />
                </WhoRow>
            </Overlay>
            <Hint>{t('SocialPosts.preview.storyHint')}</Hint>
        </Card>
    );
};

export default PlatformCardStory;
